import { Rarity } from '#src/__generated__/globalTypes.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { EssenceBalance } from '#src/components/balance/EssenceBalance/index.tsx';
import { GemsBalance } from '#src/components/commonGame/GemsBalance/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { getCommonCardShardsCount } from '#src/lib/currentUser/index.tsx';
import { useCommonGameSet } from '#src/set/index.ts';

type Props = {
  cardSetSlugs?: readonly string[];
};
export const SeriesBalance = ({ cardSetSlugs }: Props) => {
  const commonGameSet = useCommonGameSet();
  const { currentUser } = useCurrentUserContext();

  return (
    <Horizontal>
      <GemsBalance balance={currentUser?.gemsBalances[0]?.amount || 0} />
      {cardSetSlugs?.map(
        slug =>
          slug === commonGameSet.slug && (
            <EssenceBalance
              key={slug}
              value={getCommonCardShardsCount(currentUser, slug) || 0}
              rarity={Rarity.common}
              cardSetSlug={slug}
            />
          )
      )}
    </Horizontal>
  );
};
